import type { NeighbourhoodSpec } from './locationPageConfig.types.js';

/** Additional high-intent towns in the Kochi GMB service-area radius. */
export const KOCHI_MORE_HYPERLOCAL_SPECS: NeighbourhoodSpec[] = [
  {
    key: 'kodakara',
    name: 'Kodakara',
    slug: 'cleaning-service-kodakara',
    eyebrow: 'Kodakara, NH 544 & Chalakudy south',
    blurb:
      'Highway-town home cleaning in Kodakara between Chalakudy and Thrissur. NH 544 apartments and family houses on the Greater Kochi dispatch.',
    highlightIcon: 'Bus',
    highlightText: 'NH 544 Kodakara',
    areas: ['Kodakara Town', 'NH 544 Kodakara', 'Chalakudy south', 'Pudukkad approach', 'Amballur edge'],
    landmarks: ['Kodakara Junction', 'NH 544', 'Chalakudy south'],
    nearby: ['Chalakudy', 'Irinjalakuda', 'Thrissur'],
    related: [
      { name: 'Chalakudy', href: '/cleaning-service-chalakudy' },
      { name: 'Irinjalakuda', href: '/cleaning-service-irinjalakuda' },
      { name: 'Thrissur', href: '/cleaning-service-thrissur' },
    ],
    reviews: [
      {
        name: 'Vimal P.',
        location: 'Kodakara',
        text: 'Town house before Onam. Crew used the highway slot we booked.',
      },
      { name: 'Renu S.', location: 'NH 544', text: 'Apartment balcony wash. Truck dust was the issue.' },
      {
        name: 'Jibin T.',
        location: 'Kodakara',
        text: 'Kitchen and bathrooms. Same rate as Kochi on the form.',
      },
    ],
  },
  {
    key: 'koratty',
    name: 'Koratty',
    slug: 'cleaning-service-koratty',
    eyebrow: 'Koratty, Karukutty & Airport highway',
    blurb:
      'Home cleaning in Koratty on the Angamaly–Chalakudy belt. Airport-highway houses and new apartments that pick up NH 544 dust all week.',
    highlightIcon: 'Building',
    highlightText: 'Airport-highway town',
    areas: ['Koratty Town', 'Karukutty edge', 'NH 544 Koratty', 'Angamaly north', 'Chalakudy south-west'],
    landmarks: ['Koratty Junction', 'NH 544', 'Karukutty'],
    nearby: ['Karukutty', 'Angamaly', 'Chalakudy'],
    related: [
      { name: 'Karukutty', href: '/cleaning-service-karukutty' },
      { name: 'Angamaly', href: '/cleaning-service-angamaly' },
      { name: 'Chalakudy', href: '/cleaning-service-chalakudy' },
    ],
    reviews: [
      {
        name: 'Anil K.',
        location: 'Koratty',
        text: '2BHK deep clean. Highway dust in window tracks is gone.',
      },
      {
        name: 'Meera J.',
        location: 'Koratty',
        text: 'Booked while at work. Photos on WhatsApp at handover.',
      },
      { name: 'Sandeep R.', location: 'Koratty', text: 'Bathroom anti-fungal before monsoon.' },
    ],
  },
  {
    key: 'karukutty',
    name: 'Karukutty',
    slug: 'cleaning-service-karukutty',
    eyebrow: 'Karukutty, Angamaly north & Koratty',
    blurb:
      'Town-home cleaning in Karukutty next to Angamaly. Family houses and NH-side flats on the airport corridor.',
    highlightIcon: 'MapPin',
    highlightText: 'Angamaly-north town',
    areas: ['Karukutty Town', 'Angamaly north', 'Koratty south', 'NH 544 Karukutty', 'Mookkannoor edge'],
    landmarks: ['Karukutty Town', 'NH 544', 'Angamaly north'],
    nearby: ['Angamaly', 'Koratty', 'Kalady'],
    related: [
      { name: 'Angamaly', href: '/cleaning-service-angamaly' },
      { name: 'Koratty', href: '/cleaning-service-koratty' },
      { name: 'Kalady', href: '/cleaning-service-kalady' },
    ],
    reviews: [
      { name: 'Lijo M.', location: 'Karukutty', text: 'Independent house including sit-out. On time.' },
      { name: 'Anna P.', location: 'Karukutty', text: 'Kitchen chimney degrease. Grease actually lifted.' },
      { name: 'Vivek S.', location: 'Karukutty', text: 'No extra travel fee at checkout.' },
    ],
  },
  {
    key: 'chengamanad',
    name: 'Chengamanad',
    slug: 'cleaning-service-chengamanad',
    eyebrow: 'Chengamanad, Athani & Airport Road',
    blurb:
      'Village-and-highway home cleaning in Chengamanad between Athani and Aluva. Airport-road houses on the CIAL corridor.',
    highlightIcon: 'Bus',
    highlightText: 'Airport-road homes',
    areas: ['Chengamanad Town', 'Athani south', 'Airport Road', 'Aluva north', 'Nedumbassery west'],
    landmarks: ['Chengamanad Town', 'Airport Road', 'Athani'],
    nearby: ['Athani', 'Nedumbassery', 'Aluva'],
    related: [
      { name: 'Athani', href: '/cleaning-service-athani' },
      { name: 'Nedumbassery', href: '/cleaning-service-nedumbassery' },
      { name: 'Aluva', href: '/cleaning-service-aluva' },
    ],
    reviews: [
      { name: 'Ramesh T.', location: 'Chengamanad', text: 'Family house. Bathroom grout treatment worked.' },
      { name: 'Sita N.', location: 'Airport Road', text: 'Booked from the Athani page. Crew knew the lane.' },
      { name: 'Ajmal K.', location: 'Chengamanad', text: 'Same-day kitchen after a morning booking.' },
    ],
  },
  {
    key: 'njarakkal',
    name: 'Njarakkal',
    slug: 'cleaning-service-njarakkal',
    eyebrow: 'Njarakkal, Vypin & Goshree',
    blurb:
      'Island-home cleaning in Njarakkal on Vypin. Salt air, monsoon mould and family houses between Goshree and Nayarambalam.',
    highlightIcon: 'Waves',
    highlightText: 'Vypin island town',
    areas: ['Njarakkal Town', 'Goshree south', 'Nayarambalam', 'Edavanakkad edge', 'Vypin Ferry approach'],
    landmarks: ['Njarakkal Town', 'Goshree Bridges', 'Nayarambalam'],
    nearby: ['Vypin', 'Cherai', 'Nayarambalam'],
    related: [
      { name: 'Vypin', href: '/cleaning-service-vypin' },
      { name: 'Cherai', href: '/cleaning-service-cherai' },
      { name: 'Fort Kochi', href: '/cleaning-service-fort-kochi' },
    ],
    reviews: [
      {
        name: 'Shibu P.',
        location: 'Njarakkal',
        text: 'Villa after Onam guests. Sit-out and bathrooms reset.',
      },
      { name: 'Rani J.', location: 'Njarakkal', text: 'Window salt film is gone.' },
      { name: 'Faisal A.', location: 'Goshree south', text: 'Booked two houses the same week.' },
    ],
  },
  {
    key: 'nayarambalam',
    name: 'Nayarambalam',
    slug: 'cleaning-service-nayarambalam',
    eyebrow: 'Nayarambalam, Njarakkal & Edavanakkad',
    blurb:
      'Backwater-edge home cleaning in Nayarambalam. Family houses and weekend homes on the Vypin spine toward Cherai.',
    highlightIcon: 'Waves',
    highlightText: 'Vypin backwater homes',
    areas: ['Nayarambalam Town', 'Njarakkal north', 'Edavanakkad', 'Cherai south', 'Vypin interior'],
    landmarks: ['Nayarambalam Town', 'Backwater road', 'Edavanakkad'],
    nearby: ['Njarakkal', 'Cherai', 'Vypin'],
    related: [
      { name: 'Njarakkal', href: '/cleaning-service-njarakkal' },
      { name: 'Cherai', href: '/cleaning-service-cherai' },
      { name: 'Vypin', href: '/cleaning-service-vypin' },
    ],
    reviews: [
      {
        name: 'Biju C.',
        location: 'Nayarambalam',
        text: 'Independent house. Humidity in two bathrooms treated.',
      },
      { name: 'Tessy M.', location: 'Nayarambalam', text: 'Kitchen plus home. Fair online price.' },
      { name: 'Naveen R.', location: 'Edavanakkad', text: 'Crew found the interior road without a call.' },
    ],
  },
  {
    key: 'eramalloor',
    name: 'Eramalloor',
    slug: 'cleaning-service-eramalloor',
    eyebrow: 'Eramalloor, Aroor south & Cherthala north',
    blurb:
      'NH 66 home cleaning in Eramalloor between Aroor and Cherthala. Highway apartments and family houses on the Alappuzha-north belt.',
    highlightIcon: 'Bus',
    highlightText: 'NH 66 Eramalloor',
    areas: ['Eramalloor Town', 'NH 66 Eramalloor', 'Aroor south', 'Thuravoor north', 'Kumbalam south'],
    landmarks: ['Eramalloor Junction', 'NH 66', 'Aroor south'],
    nearby: ['Aroor', 'Thuravoor', 'Cherthala'],
    related: [
      { name: 'Aroor', href: '/cleaning-service-aroor' },
      { name: 'Thuravoor', href: '/cleaning-service-thuravoor' },
      { name: 'Cherthala', href: '/cleaning-service-cherthala' },
    ],
    reviews: [
      { name: 'Pradeep V.', location: 'Eramalloor', text: 'Highway flat. Balcony rails washed, not dusted.' },
      { name: 'Bindu L.', location: 'Eramalloor', text: 'Home + small shop the same week.' },
      { name: 'Hashim N.', location: 'NH 66', text: 'Price matched the form.' },
    ],
  },
  {
    key: 'arookutty',
    name: 'Arookutty',
    slug: 'cleaning-service-arookutty',
    eyebrow: 'Arookutty, Thuravoor & Backwaters',
    blurb:
      'Island-edge home cleaning in Arookutty. Backwater houses and temple-town families between Thuravoor and Cherthala.',
    highlightIcon: 'Waves',
    highlightText: 'Backwater island homes',
    areas: ['Arookutty Town', 'Thuravoor west', 'Cherthala north-west', 'Kumbalam south', 'Perumbalam edge'],
    landmarks: ['Arookutty Town', 'Backwater road', 'Thuravoor'],
    nearby: ['Thuravoor', 'Cherthala', 'Kumbalam'],
    related: [
      { name: 'Thuravoor', href: '/cleaning-service-thuravoor' },
      { name: 'Cherthala', href: '/cleaning-service-cherthala' },
      { name: 'Kumbalam', href: '/cleaning-service-kumbalam' },
    ],
    reviews: [
      { name: 'Gireesh P.', location: 'Arookutty', text: 'Villa sit-out and bathrooms after monsoon.' },
      { name: 'Latha S.', location: 'Arookutty', text: 'Traditional home. Team was careful with furniture.' },
      { name: 'Nithin A.', location: 'Arookutty', text: 'Booked two days out. On the promised slot.' },
    ],
  },
  {
    key: 'alangad',
    name: 'Alangad',
    slug: 'cleaning-service-alangad',
    eyebrow: 'Alangad, Aluva west & Varapuzha',
    blurb:
      'Home cleaning in Alangad between Aluva and Varapuzha. River-side houses and family homes on the north Ernakulam belt.',
    highlightIcon: 'MapPin',
    highlightText: 'Aluva–Varapuzha belt',
    areas: ['Alangad Town', 'Aluva west', 'Varapuzha south', 'Kadungalloor edge', 'Eloor east'],
    landmarks: ['Alangad Town', 'Aluva west', 'Varapuzha south'],
    nearby: ['Aluva', 'Varapuzha', 'Eloor'],
    related: [
      { name: 'Aluva', href: '/cleaning-service-aluva' },
      { name: 'Varapuzha', href: '/cleaning-service-varapuzha' },
      { name: 'Eloor', href: '/cleaning-service-eloor' },
    ],
    reviews: [
      { name: 'Sajan E.', location: 'Alangad', text: 'Family house. Bathroom fungus treated properly.' },
      { name: 'Priya C.', location: 'Alangad', text: 'Kitchen degrease. Recurring plan next.' },
      { name: 'Manoj D.', location: 'Aluva west', text: 'Crew coordinated with our gate.' },
    ],
  },
  {
    key: 'koonammavu',
    name: 'Koonammavu',
    slug: 'cleaning-service-koonammavu',
    eyebrow: 'Koonammavu, Varapuzha & North Paravur',
    blurb:
      'Town-home cleaning in Koonammavu on the Varapuzha–Paravur road. Church-side houses and new flats on the north Kochi river belt.',
    highlightIcon: 'Users',
    highlightText: 'North Kochi river town',
    areas: ['Koonammavu Town', 'Varapuzha north', 'Kongorpilly', 'North Paravur south', 'Container Road'],
    landmarks: ['Koonammavu Town', 'Varapuzha north', 'Kongorpilly'],
    nearby: ['Varapuzha', 'North Paravur', 'Cheranalloor'],
    related: [
      { name: 'Varapuzha', href: '/cleaning-service-varapuzha' },
      { name: 'North Paravur', href: '/cleaning-service-north-paravur' },
      { name: 'Cheranalloor', href: '/cleaning-service-cheranalloor' },
    ],
    reviews: [
      {
        name: 'Jaison P.',
        location: 'Koonammavu',
        text: 'Town house before a feast. Hall and kitchen first.',
      },
      { name: 'Shiny K.', location: 'Koonammavu', text: 'New flat move-in. Windows and kitchen done.' },
      { name: 'Rafi M.', location: 'Kongorpilly', text: 'Honest pricing. No surprise fee.' },
    ],
  },
  {
    key: 'kodanad',
    name: 'Kodanad',
    slug: 'cleaning-service-kodanad',
    eyebrow: 'Kodanad, Malayattoor & Periyar',
    blurb:
      'Riverside home cleaning in Kodanad near Malayattoor. Elephant-camp-side houses and Kalady-east families on the Periyar belt.',
    highlightIcon: 'Sun',
    highlightText: 'Periyar riverside',
    areas: ['Kodanad Town', 'Malayattoor west', 'Kalady east', 'Periyar road', 'Koovappady edge'],
    landmarks: ['Kodanad', 'Periyar river', 'Malayattoor west'],
    nearby: ['Malayattoor', 'Kalady', 'Perumbavoor'],
    related: [
      { name: 'Malayattoor', href: '/cleaning-service-malayattoor' },
      { name: 'Kalady', href: '/cleaning-service-kalady' },
      { name: 'Perumbavoor', href: '/cleaning-service-perumbavoor' },
    ],
    reviews: [
      {
        name: 'Eldho V.',
        location: 'Kodanad',
        text: 'House near the river. Humidity treatment in bathrooms.',
      },
      { name: 'Anu G.', location: 'Kodanad', text: 'Booked from Malayattoor page. Same crew quality.' },
      { name: 'Bibin S.', location: 'Periyar road', text: 'Kitchen and sit-out. On time.' },
    ],
  },
  {
    key: 'annamanada',
    name: 'Annamanada',
    slug: 'cleaning-service-annamanada',
    eyebrow: 'Annamanada, Mala & Chalakudy',
    blurb:
      'Town-home cleaning in Annamanada between Mala and Chalakudy. Church-side houses on the Thrissur-south / Kodungallur belt.',
    highlightIcon: 'Users',
    highlightText: 'Mala–Chalakudy town',
    areas: ['Annamanada Town', 'Mala east', 'Chalakudy west', 'Mala Road', 'Ashtamichira'],
    landmarks: ['Annamanada Town', 'Mala Road', 'Chalakudy west'],
    nearby: ['Mala', 'Chalakudy', 'Kodungallur'],
    related: [
      { name: 'Mala', href: '/cleaning-service-mala' },
      { name: 'Chalakudy', href: '/cleaning-service-chalakudy' },
      { name: 'Kodungallur', href: '/cleaning-service-kodungallur' },
    ],
    reviews: [
      {
        name: 'Davis T.',
        location: 'Annamanada',
        text: 'Independent house. Outdoor and interiors in one visit.',
      },
      { name: 'Jency P.', location: 'Annamanada', text: 'Bathroom grout before monsoon.' },
      { name: 'Arun C.', location: 'Mala Road', text: 'No locality surcharge.' },
    ],
  },
];
